export default value => (typeof value === 'boolean' ? value.toString() : value)



// WEBPACK FOOTER //
// ./src/utils/renderValue.js